import { forwardRef } from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import Icons from '../../Elements/Icons/index.ts';
import { Wrapper, Item } from './styled.ts';
import { MarkerSelectValue } from './types.ts';

export interface MarkerSelectProps {
  value?: MarkerSelectValue;
  onChange: (value?: MarkerSelectValue) => void;
  disabled?: boolean;
}

export const MarkerSelect = forwardRef<HTMLDivElement, MarkerSelectProps>(function MarkerSelect({ value, onChange, disabled }, ref) {
  const handleOnClick = useCallbackRef((item: MarkerSelectValue) => {
    if (!disabled) {
      onChange(item === value ? undefined : item);
    }
  });

  return (
    <Wrapper ref={ref}>
      {Object.values(MarkerSelectValue).map((marker) => (
        <Item
          key={marker}
          $isSelected={value === marker}
          $isDisabled={disabled}
          $marker={marker}
          onClick={() => handleOnClick(marker)}
          data-testid={`${marker}-marker`}
          data-selected={value === marker}>
          {value === marker ? (
            <>
              <Icons.Checkmark size={12} alt dataTestId='checkmark-icon' />
              <Icons.Close size={12} alt dataTestId='close-icon' />
            </>
          ) : (
            <Icons.Plus size={14} alt dataTestId='plus-icon' />
          )}
        </Item>
      ))}
    </Wrapper>
  );
});

MarkerSelect.displayName = 'MarkerSelect';
